// extracted by mini-css-extract-plugin
export default {"headerBar":"gJ-z","pointsSection":"hJ-z","goToDashboard":"iJ-z"};